// @view/document/review/SectionTitleError.view.tsx
import React from "react";
import * as styles from "@styles/SectionModal.css";
import type { DocumentReviewViewProps } from "@ps-bridge/contracts/documentReview";

type SectionTitleErrorViewProps = Pick<
  DocumentReviewViewProps,
  "sectionTitleErrorMessage"
>;

const SectionTitleErrorView: React.FC<SectionTitleErrorViewProps> = ({
  sectionTitleErrorMessage,
}) => {
  return (
    <p className={styles.errorText} data-testid="review-new-section-error">
      {sectionTitleErrorMessage}
    </p>
  );
};

export default SectionTitleErrorView;
